import axios from 'axios';
import CryptoJS from 'crypto-js';
import { postApi } from '../../lib/fetcher';

const fill = {
  namespaced: true,

  state() {
    return {
      allData: [],
      totalData: 0,
      totalPage: 0,
      item: {
        id: '',
        source_onboarding: '',
        merchant_name: '',
        reference_number: '',
        kode_wilayah: '',
        tipe_merchant: '',
        created_at: '',
      },
      loading: false,
      errors: [],
      flashError: false,
      flashErrorMessage: '',
      requestData: null,
      updatedFill: false,
    };
  },
  mutations: {
    setData(state, { payload }) {
      state.allData = payload.data.list;
    },
    setTotalData(state, { payload }) {
      state.totalData = parseInt(payload.data.countdata, 10);
      state.totalPage = parseInt(payload.data.totalPage, 10);
    },
    clearData(state) {
      state.allData = [];
      state.totalData = 0;
    },
    setItem(state, { payload }) {
      state.item = payload.data;
    },
    setFlashErrorMessage(state, payload) {
      state.flashErrorMessage = payload;
      state.flashError = payload !== '';
    },
    clearErrors(state) {
      state.errors = [];
    },
    setErrors(state, payload) {
      state.errors = payload;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
    setCancelation(state, payload) {
      state.requestData = payload;
    },
    setUpdatedFill(state, payload) {
      state.updatedFill = payload;
    },
  },

  actions: {
    async getData(ctx, { date, page, itemsPerPage, search }) {
      if (ctx.state.requestData) ctx.state.requestData.cancel();

      const axiosSource = axios.CancelToken.source();

      ctx.commit('setCancelation', {
        cancel: axiosSource.cancel,
        msg: 'Loading...',
      });

      ctx.commit('clearData');

      const data = JSON.stringify({
        page: page.toString(),
        limit: itemsPerPage.toString(),
        search,
        sortBy: 'id DESC',
        version: btoa(
          CryptoJS.SHA256(
            itemsPerPage.toString() +
              page.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/reserved_mid/reserved-mid/list-empty-data`;

      const addConfig = { cancelToken: axiosSource.token };

      const responseData = await postApi(ctx, urlApi, data, addConfig);

      if (responseData?.code == '200') {
        ctx.commit('setTotalData', { payload: responseData });
        ctx.commit('setData', { payload: responseData });
      }
    },

    async getDetail(ctx, { date, id }) {
      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        id,
        version: btoa(
          CryptoJS.SHA256(
            date + atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/reserved_mid/reserved-mid/detail`;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData?.code == 200) {
        ctx.commit('setItem', { payload: responseData });
      }
    },

    async bulkApprove(ctx, { date, id }) {
      const data = JSON.stringify({
        id,
        version: btoa(
          CryptoJS.SHA256(
            date + atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/reserved_mid/reserved-mid/fill-empty-data`;

      const responseData = await postApi(ctx, urlApi, data);

      let returnVal = false;

      if (responseData?.code == '200') {
        returnVal = responseData.data;
        ctx.commit('setUpdatedFill', true);
      }

      return returnVal;
    },
  },
};

export default fill;
